import Immutable from "immutable";

import { put, call } from "redux-saga/effects";
import { arrayToEntityMap } from "lib/data";
import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { fetchHistorySucceeded } from "state/school_money/actions";

import ClubHistoryItem from "state/school_money/entities/ClubHistoryItem";
import DinnerHistoryItem from "state/school_money/entities/DinnerHistoryItem";
import MealHistoryItem from "state/school_money/entities/MealHistoryItem";
import PaymentHistoryItem from "state/school_money/entities/PaymentHistoryItem";

export default function* fetchHistorySaga() {
  const response = yield call(sendSchoolMoneyDataRequest, "get_history");

  const historyList = new Immutable.List( response.data.history );
  const historyByType = historyList.groupBy(rawHistoryItem => rawHistoryItem.type);

  const clubHistoryList = historyByType.get("club", []);
  const clubHistoryByID = arrayToEntityMap(ClubHistoryItem.fromAppserver, item => item.id, clubHistoryList);

  const dinnerHistoryList = historyByType.get("dinner", []);
  const dinnerHistoryByID = arrayToEntityMap(DinnerHistoryItem.fromAppserver, item => item.id, dinnerHistoryList);

  const mealHistoryList = historyByType.get("meal", []);
  const mealHistoryByID = arrayToEntityMap(MealHistoryItem.fromAppserver, item => item.id, mealHistoryList);

  const paymentHistoryList = historyByType.get("payment", []);
  const paymentHistoryByID = arrayToEntityMap(PaymentHistoryItem.fromAppserver, item => item.id, paymentHistoryList);

  const allHistory = new Immutable.Map({
    club: clubHistoryByID,
    dinner: dinnerHistoryByID,
    meal: mealHistoryByID,
    payment: paymentHistoryByID
  });

  yield put(fetchHistorySucceeded(allHistory));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/fetchHistorySaga.js